import { State } from '../store';

export const selectRegistration = (store: State) => store.registration;

export const selectFormInfo = (store: State) => store.registration.formInfo;
export const selectGoal = (store: State) => store.registration.goal;
export const selectClinic = (store: State) => store.registration.clinic;
export const selectUrgency = (store: State) => store.registration.urgency;
export const selectCustomDiagnosis = (store: State) => store.registration.customDiagnosis;
export const selectDiagnoses = (store: State) => store.registration.diagnoses;
export const selectDescription = (store: State) => store.registration.description;
export const selectPatient = (store: State) => store.registration.patient;
export const selectDoctor = (store: State) => store.registration.doctor;
export const selectUploads = (store: State) => store.registration.uploads;
export const selectCaptchaToken = (store: State) => store.registration.captchaToken;
export const selectValidation = (store: State) => store.registration.validation;
